import { forwardRef } from "react";

import Box from "@/components/Box";

const Center = forwardRef(({ children, stacked, ...rest }, ref) => {
  const props = {
    flexDirection: stacked ? "column" : "row",
    ...rest
  };

  return (
    <Box ref={ref} {...props}>
      {children}
    </Box>
  );
});

Center.defaultProps = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
};

export default Center;
